import { useIsSmallChatBreakpoint } from '@/hooks/useIsSmallChatBreakpoint'
import { useDraftWorkspace } from './useDraftWorkspace'

/**
 * Whether a source opened from this view goes in the drafting chat panel, which is what tells the
 * surfaces that open sources whether to open the viewer or fall back to a new browser tab.
 *
 * The panel holds a source only in the draft workspace, and only on screens wide enough to dock the
 * panel there at all. A collapsed panel still counts, which is what lets a source keep its scroll
 * position across a collapse.
 */
export function useSourceOpensInChatPanel(): boolean {
  const { draftArtifactVersionId } = useDraftWorkspace()
  const isSmallScreen = useIsSmallChatBreakpoint()

  return Boolean(draftArtifactVersionId) && !isSmallScreen
}
